@if($spinner | async; as spinner){
<div class="spinner-overlay">
    <p-progressSpinner class="fixed spinner-position" ariaLabel="email loading spinner" strokeWidth="3" />
</div>
}
